@if (showMap() && !!coordinates()) {
  <div class="row my-2">
    <div class="col">
      <app-map [coords]="coordinates()"></app-map>
    </div>
  </div>
}
<div *transloco="let t" class="row" [class.finished]="isFinished()">
  <div class="col-12 col-md-4">

    @if (schedule().venue) {
      <lucide-icon [img]="icons.map"></lucide-icon>
      <span class="ms-1">{{ venueText() }}</span>

      @if (!!coordinates()) {
        <button type="button" class="btn btn-sm btn-link" (click)="toggleShowMap()">
          {{ showMap() ? 'Cacher la carte' : 'Voir la carte' }}
        </button>
      }

    }
  </div>
  <div class="col-12 col-md-4">
    <app-schedule-time
      [activity]="activity()"
      [schedule]="schedule()">
    </app-schedule-time>

    @if (schedule().hasSupervisor) {
      <div class="my-1">
        <lucide-icon [img]="icons.supervisor"></lucide-icon>
        <span class="ms-1">Encadré par un·e responsable</span>
      </div>
    }
  </div>
  <div class="col-12 col-md-4">
    @if (genderString()) {
      <div class="my-1">
        <app-person-gender-icon [gender]="schedule()?.gender"></app-person-gender-icon>
        <span class="ms-1">{{ genderString() }}</span>
      </div>
    }
    @if (ageString()) {
      <div class="my-1">
        <lucide-icon [img]="icons.age"></lucide-icon>
        <span class="ms-1">{{ ageString() }}</span>
      </div>
    }
    @if (levelString()) {
      <div class="my-1">
        <app-schedule-level-icon [level]="schedule().level"></app-schedule-level-icon>
        <span class="ms-1">{{ levelString() }}</span>
      </div>
    }
  </div>
  @if (schedule()?.description) {
    <div class="col-12">
      <p class="ml-description my-1" [class.finished]="isFinished()">
        {{ schedule().description }}
      </p>
    </div>
  }
</div>
